import {
  Injectable,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import * as L from 'leaflet';
import * as moment from 'moment';
import 'leaflet.markercluster';
import 'leaflet.markercluster.freezable';

import { WebSocketDataService } from 'src/app/vehicles/services/webSocketData.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { FollowService } from 'src/app/vehicles/services/follow.service';
import { IMapMinimap, UserTracker } from '../models/interfaces';
import { EventService } from 'src/app/events/services/event.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import { IfStmt } from '@angular/compiler';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { UserIconsService } from 'src/app/profile-config/services/user-icons.service';
import { tap } from 'rxjs/operators';
import { UnitWithTransmissionStatus } from 'src/app/units/models/unit-transmission-status';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { convertSecondsToTimeString } from 'src/app/vehicles/components/content-panel-vehicles/helpers/convert-seconds-to-time-string';

@Injectable({
  providedIn: 'root',
})
export class MinimapService {
  @ViewChild('popupText') popupText!: ElementRef;

  private focusMapSubject = new BehaviorSubject<string | null>(null);
  focusMap$ = this.focusMapSubject.asObservable();
  private focusTimer?: Subscription;

  public units: UnitWithTransmissionStatus[] = [];

  private mapsSubject = new BehaviorSubject<IMapMinimap[]>([]);
  public maps$ = this.mapsSubject.asObservable();

  public maps: IMapMinimap[] = [];
  public respuesta: any = [];
  public markerClusterGroupOnda!: any;

  public markerClusterData!: any;

  public leafletEvent!: L.LeafletEvent;

  private marker: any = [];

  private clustering = true;

  dif_mayor = 0.0;
  dif_divide = 0.0;
  dif_X = 0.0;
  dif_Y = 0.0;
  direction = '';
  final_direction = '';
  direction_X = '';
  direction_Y = '';
  vehicleServiceIsReady = false;

  timeNow: any = []; // Array para almacenar los tiempos
  timeWait: number = 7200000; // 7200000 milisegundos en milisegundos

  @Output() sendData = new EventEmitter<any>();
  @Output() vehicleServiceReady = new EventEmitter<any>();
  @Output() changeEye = new EventEmitter<any>();

  constructor(
    private vehicleService: VehicleService,
    private webSocketDataService: WebSocketDataService,
    private userDataService: UserDataService,
    private userIconsService: UserIconsService,
    public eventService: EventService,
    public driversService: DriversService,
    private momentService: MomentService,
    public unitTransmissionStatusService: UnitTransmissionStatusService
  ) {
    // this.driversService.initialize();
    this.userDataService.getUserData();
    this.userDataService.userDataCompleted.subscribe((res) => {
      this.driversService.initialize(); //NECESITA INFO DE USER DATA
      this.vehicleService.setDefaultStatusDataVehicle();
      this.vehicleService.initialize();
    });

    this.vehicleService.dataCompleted.subscribe((vehicles) => {
      console.log('user data completadoooo', vehicles);
      this.vehicleServiceIsReady = true;
      this.vehicleServiceReady.emit(vehicles);
    });
    this.webSocketDataService.callback.subscribe((res) => {
      this.monitor(res);
    });

    this.vehicleService.calcTimeStop.subscribe((data) => {
      // console.log("event time stop res = ",data);
      if (this.units.length > 0) {
        this.createPopupWithUnitService(data);
        return;
      }

      let tiempoParada = '';
      //
      let aux_vehicle = this.vehicleService.getVehicle(data.imei);
      //
      let a = moment(new Date(data.dt_tracker));
      let b = moment(new Date());
      let d = moment(new Date(aux_vehicle.dt_tracker));

      /*
      c es el tiempo que demora en retornar la info desde backend (latencia)
      e corresponde a la ultima transmision???
      */
      let c = b.diff(a, 'seconds'); //retorno
      let e = d.diff(a, 'seconds'); //diff fecha
      // let c = 100;
      //dt_tracker es fecha tracker
      // console.log("speed  = ",data.speed);
      // console.log("calc c = ",c);
      // console.log("calc e = ",e);
      if (e == 0) {
        if (data.speed > 3 && c > 60) {
          // console.log("se cumplio condicion : item.speed > 3 km/h && c > 60 seg ");
          tiempoParada = '0 s';
        } else if (parseInt(data.res) == -1) {
          tiempoParada = 'Apagado mas de un día'; //"No se encontro Datos";
        } else if (parseInt(data.res) == -2) {
          tiempoParada = 'Duración mayor a 1 Dia';
        } else if (parseInt(data.res) == -3) {
          tiempoParada = 'En movimiento...';
        } else if (parseInt(data.res) == -5) {
          //inicio de parada
          tiempoParada = '0 s';
        } else if (parseInt(data.res) == -6) {
          //inicio de parada
          tiempoParada = '...Avise a soporte';
        } else if (parseInt(data.res) == -4) {
          // var tiempoParada = "En movimiento...";
          // item.paradaDesde  = item.paradaDesde;

          //var f_now = new Date( item.dt_tracker.replace(/-/g, "/") );
          let f_now = new Date();
          let f_past = new Date(data.paradaDesde);
          // var anios=f_now.diff(f_past,"seconds");
          let duracion = this.string_diffechas(f_past, f_now);
          //var tiempoParada = item.paradaDesde  + " - " +item.dt_tracker+ " - " +duracion;
          tiempoParada = duracion;
        } else {
          data.paradaDesde = data.res;

          //var f_now = new Date( item.dt_tracker.replace(/-/g, "/") );
          // let aux = moment(data.paradaDesde).subtract(5, 'hours').format('YYYY-MM-DD HH:mm:ss');
          let f_now = new Date();
          // let f_past = new Date( aux );
          let f_past = new Date(data.paradaDesde);
          // let anios=f_now.diff(f_past,"seconds");
          let duracion = this.string_diffechas(f_past, f_now);
          // let tiempoParada = responseP[0] + " - " +item.dt_tracker+ " - " +duracion;
          tiempoParada = duracion;
        }
        // console.log("tiempoParada = ",tiempoParada);
        let aux = {
          imei: data.imei,
          name: data.name,
          dt_tracker: data.dt_tracker,
          nameconvoy: data.nameconvoy,
          namegrupo: data.namegrupo,
          nameoperation: data.nameoperation,
          namedriver: data.namedriver,
          longitud: data.longitud,
          latitud: data.latitud,
          speed: data.speed,
          ref: data.direction,
          tiempoParada: tiempoParada,
        };
        // console.log("auxxxx",aux);

        //Una vez llegado el evento con la data de tiempo de parada de un vehiculo,
        //Buscamos a que mapas pertenece el vehiculo y actualizamos el valor de imeiPopu y time_stop
        // de cada mapa ya que seran tomados al llamar a printPopup con el mapa correspondiente
        this.currentMaps.forEach((item) => {
          item.minimapConf!.vehicles?.forEach((element) => {
            if (element.IMEI!.toString() == data.imei.toString()) {
              item.imeiPopup = data.imei;
              item.time_stop = tiempoParada;
              this.printPopup(aux, item); //que actualice el popup en el mapa con tal id
            }
          });
        });
      }
    });

    this.eventService.newEventStream.subscribe((events) => {
      this.onEvent(events);
    });

    unitTransmissionStatusService.getUnitsTransmissionStatus
      .pipe(
        tap((_) => {
          this.units = _;
          const updatedMaps = this.currentMaps.map((map) => {
            this.renderVehiclesTransmission(map);
            if (this.currentPopupData) {
              this.createPopupWithUnitService(this.currentPopupData);
            }
            return map;
          });
          this.mapsSubject.next(updatedMaps);
        })
      )
      .subscribe();
  }

  get currentMaps(): IMapMinimap[] {
    return this.mapsSubject.getValue();
  }

  private currentPopupData: any;

  private createPopupWithUnitService(data: any) {
    if (this.units.length > 0) {
      const unit = this.units.find((unit) => unit.GNSSIMEI == data.imei);
      if (unit) {
        const nameDriver = data.namedriver
          ? data.namedriver
          : 'Conductor desconocido';
        this.currentPopupData = data;
        const infoPopup = {
          imei: unit?.GNSSIMEI,
          name: unit?.unitName,
          dt_tracker: unit?.device.trackerDate.toLocaleString(),
          nameconvoy: unit?.convoy,
          namegrupo: unit?.group,
          nameoperation: unit?.operation,
          namedriver: nameDriver,
          longitud: data.longitud,
          latitud: data.latitud,
          speed: unit?.device.speed,
          ref: data.direction || 'Cargando...',
          tiempoParada:
            unit?.transmissionStatusId === 1
              ? '0s'
              : convertSecondsToTimeString(unit?.latlngTimeElapsed || 0, {
                  shortFormat: true,
                  showZeros: false,
                }),
        };

        this.currentMaps.forEach((item) => {
          item.minimapConf!.vehicles?.forEach((element) => {
            if (element.IMEI!.toString() == data.imei.toString()) {
              this.printPopup(infoPopup, item); //que actualice el popup en el mapa con tal id
            }
          });
        });
      }
    }
  }

  onEvent(events: any) {
    const aux = events[0];
    this.currentMaps.forEach((item) => {
      const resultado = item.minimapConf?.vehicles!.find(
        (vehi) => vehi.IMEI?.toString() == aux.tracker_imei.toString()
      );
      if (resultado) {
        item.minimapConf!.events?.unshift(aux);
        item.minimapConf!.nEvents = item.minimapConf?.events?.filter(
          (ev) => ev.viewed == false
        ).length;
      }
    });
  }

  resetMaps() {
    this.mapsSubject.next([]);
  }
  removeMapById(containerId: string) {
    const updated = this.currentMaps.filter(
      (map) => map.containerId !== containerId
    );
    this.mapsSubject.next(updated);
  }
  addNewMap(newMap: IMapMinimap) {
    console.log('minimap : nuevo mapa agregar', newMap);
    this.onDrawIcon(newMap);
    this.mapsSubject.next([...this.currentMaps, newMap]);
  }
  resizeMaps() {
    this.currentMaps.forEach((item) => {
      item.map?.invalidateSize();
    });
  }
  getVehicles() {
    return this.vehicleService.vehicles;
  }

  setNameGroup(nameOpe: string, nameGru: string, nameCon: string): string {
    if (nameCon != 'Unidades sin convoy') {
      if (nameGru != 'Unidades sin grupo') {
        if (nameOpe != 'Unidades sin operación') {
          return nameOpe + ' / ' + nameGru + ' / ' + nameCon;
        } else {
          return nameCon + ' / ' + nameGru;
        }
      } else {
        return nameCon;
      }
    } else {
      return '';
      // return 'Vehículo Sin Agrupación';
    }
  }
  onDrawIcon(mapItem: IMapMinimap): void {
    console.log('onDrawIcon');
    const e = mapItem.minimapConf!.vehicles!;

    const transmissionStatusColor: any = {
      10: 'green',
      20: 'blue',
      30: 'purple',
      40: 'black',
      50: 'orange',
      60: 'red',
      100: 'transm-color-not-defined',
    };

    mapItem.markerClusterGroup.clearLayers();
    mapItem.markerClusterGroupOnda.clearLayers();

    for (const property in e) {
      // console.log('e----- ', property);
      // console.log('e.hasOwnProperty(property)', e.hasOwnProperty(property));
      // console.log('e[property].eye', e[property].eye);
      if (e.hasOwnProperty(property) && e[property].eye == true) {
        this.drawIcon(e[property], mapItem);
      }
    }

    if (mapItem.minimapConf.mapConf!.dataFitBounds!.length > 0) {
      // //console.log("dataFitBounds map",this.dataFitBounds);
      mapItem.setFitBounds(mapItem.minimapConf.mapConf?.dataFitBounds!);
    }
    //EVENTO cluster lista
    mapItem.markerClusterGroup.on('clusterclick', function (a: any) {
      //console.log('click cluster...........');
      var coords = a.layer.getLatLng();
      //console.log(a.layer.getAllChildMarkers());
      var lista = '<table class="infovehiculos"><tbody>';
      var array = a.layer.getAllChildMarkers();
      //console.log('array'+array);
      for (const i in array) {
        var aaa = array[i]['_tooltip']['_content'];
        //console.log(aaa.replace(/<\/?[^>]+(>|$)/g, ""));
        var vehicleData = e.find(
          (vehicle: UserTracker) =>
            vehicle.name == aaa.replace(/<\/?[^>]+(>|$)/g, '')
        );
        var transmissionColorClass =
          typeof vehicleData != 'undefined'
            ? transmissionStatusColor[vehicleData.point_color!]
            : 'transm-color-not-defined';
        lista =
          lista +
          '<tr><td><div class="dot-vehicle ' +
          transmissionColorClass +
          '"></div></td><td>' +
          aaa +
          '</td></tr>';
      }

      lista = lista + '</tbody></table>';

      var popupMarker = L.popup({
        maxHeight: 400,
        closeButton: false,
        closeOnClick: true,
        autoClose: true,
        className: 'popupList',
      })
        .setLatLng([coords.lat, coords.lng])
        .setContent(lista)
        .openOn(mapItem.map!);
    });
  }

  public async getUrlByStateOndas(data: any): Promise<string> {
    if (data?.speed != 0 && data?.speed! < data?.limit_speed!) {
      return './assets/images/objects/nuevo/gif/onda_verde.gif';
    } else if (data?.speed != 0 && data?.speed! > data?.limit_speed!) {
      return './assets/images/objects/nuevo/gif/onda_roja.gif';
    } else if (data?.speed == 0) {
      return './assets/images/objects/nuevo/gif/onda_azul.gif';
    } else {
      return './assets/images/objects/nuevo/gif/blanco.png';
    }
  }

  private async drawIcon(data: any, mapItem: IMapMinimap): Promise<void> {
    let iconUrl;
    if (await this.hasParamIgnition(data)) {
      if (await this.checkParamIgnition(data)) {
        iconUrl = await this.getIconUrlTransmission(data);
      } else {
        iconUrl = await this.getIconUrlTransmission(data);
        //iconUrl = await MinimapService.loadAndConvertSVGToPNG(await this.userIconsService.getDirectionSvg(data.tipo!,'default'));
      }
    } else {
      iconUrl = await this.getIconUrlTransmission(data);

      //iconUrl = await MinimapService.loadAndConvertSVGToPNG(await this.userIconsService.getDirectionSvg(data.tipo!,'default'));
    }
    if (this.userIconsService.changeItemIcon == 'ondas') {
      let iconUrl2 = './assets/images/objects/nuevo/gif/blanco.png';
      if (await this.hasParamIgnition(data)) {
        if (await this.checkParamIgnition(data)) {
          iconUrl2 = await this.setIconUrlOndaByState(data);
        }
      }
      const myIcono = L.icon({
        iconUrl: iconUrl2,
        iconSize: [60, 60],
        iconAnchor: [33, 43],
      });

      const tempMarker1 = L.marker([data.latitud, data.longitud], {
        icon: myIcono,
      }).setZIndexOffset(-1);
      mapItem.markerClusterGroupOnda.addLayer(tempMarker1, {
        renderer: L.canvas(),
      });
      mapItem.markerClusterGroupOnda.addTo(mapItem.map, {
        renderer: L.canvas(),
      });
    }

    const iconMarker = L.icon({
      iconUrl: iconUrl || '',
      iconSize: [55, 55],
      iconAnchor: [30, 45],
      popupAnchor: [-3, -40],
    });
    //console.log('data.name',data.name);
    let nameGroup = this.setNameGroup(
      data.nameoperation,
      data.namegrupo,
      data.nameconvoy
    );
    const googleMapsLink = `https://www.google.com/maps?q=${data.latitud},${data.longitud}`;
    const dt_tracker = data.dt_tracker
      ? (() => {
          try {
            const dateStr = data.dt_tracker.toString().trim();

            // Normalizar AM/PM con espacios flexibles
            let normalizedDateStr = dateStr
              .replace(/p\.\s*m\./gi, 'PM')
              .replace(/a\.\s*m\./gi, 'AM')
              .replace(/\s+/g, ' '); // Normalizar espacios múltiples

            // Regex más flexible para diferentes formatos
            const dateTimeMatch = normalizedDateStr.match(
              /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}),?\s*(.+)/
            );

            if (dateTimeMatch) {
              const [, day, month, year, time] = dateTimeMatch;
              normalizedDateStr = `${month}/${day}/${year} ${time}`;
            }

            const parsedDate = new Date(normalizedDateStr);

            if (isNaN(parsedDate.getTime())) {
              console.error('(MAP) ERROR AL PARSEAR FECHA:', {
                original: dateStr,
                normalized: normalizedDateStr,
                parsedDate: parsedDate,
                getTime: parsedDate.getTime(),
              });
              return '00/00/0000 00:00:00';
            }

            return parsedDate
              .toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
              })
              .replace(',', '');
          } catch (error) {
            console.error(
              '❌ ERROR INESPERADO AL PARSEAR FECHA:',
              error,
              data.dt_tracker
            );
            return '00/00/0000 00:00:00';
          }
        })()
      : '00/00/0000 00:00:00';
    let hasPermission = false;
    const permissionList = localStorage.getItem('PermissionList');
    if (permissionList) {
      const content: string[] = JSON.parse(permissionList ?? '[]');
      hasPermission = content.some(
        (permission) => permission === 'vehicle_history'
      );
    }

    let newContent;
    if (nameGroup) {
      newContent =
        '<div class="modern-popup-container">' +
        '<div class="popup-header">' +
        '<div class="vehicle-info">' +
        '<h6 class="vehicle-name" id="vehicle-name-' +
        data.imei +
        '" title="Copiar nombre del vehículo">' +
        data.name +
        '</h6>' +
        '<span class="speed-badge">' +
        data.speed +
        ' km/h</span>' +
        '</div>' +
        '</div>' +
        '<div class="popup-body">' +
        '<div class="group-info">' +
        '<i class="fas fa-layer-group text-muted"></i>' +
        '<span class="group-name">' +
        nameGroup +
        '</span>' +
        '</div>' +
        '<div class="info-grid">' +
        '<div class="info-item">' +
        '<i class="fas fa-user-circle" title="Conductor"></i>' +
        //'<span class="info-label">Conductor:</span>' +
        '<span class="info-value" id="driver-' +
        data.imei +
        '-content">' +
        data.namedriver +
        '</span>' +
        '<button class="copy-btn" id="driver-' +
        data.imei +
        '" title="Copiar conductor">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
        // '<span class="info-label">Ubicación:</span>' +
        '<a href="' +
        googleMapsLink +
        '" target="_blank" class="location-link" id="location-' +
        data.imei +
        '-content">' +
        data.latitud +
        ', ' +
        data.longitud +
        '</a>' +
        '<button class="copy-btn" id="location-' +
        data.imei +
        '" title="Copiar ubicación">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
        // '<span class="info-label">Referencia:</span>' +
        '<span class="info-value" id="reference-' +
        data.imei +
        '-content">' +
        data.ref +
        '</span>' +
        '<button class="copy-btn" id="reference-' +
        data.imei +
        '" title="Copiar referencia">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-clock" title="Transmisión"></i>' +
        // '<span class="info-label">Transmisión:</span>' +
        '<span class="info-value" id="transmission-' +
        data.imei +
        '-content">' +
        dt_tracker +
        '</span>' +
        '<button class="copy-btn" id="transmission-' +
        data.imei +
        '" title="Copiar transmisión">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-pause-circle" title="Tiempo Detenedio"></i>' +
        // '<span class="info-label">T. Detenedio:</span>' +
        '<span class="info-value" id="stoptime-' +
        data.imei +
        '-content">' +
        data.tiempoParada +
        '</span>' +
        '<button class="copy-btn" id="stoptime-' +
        data.imei +
        '" title="Copiar tiempo de parada">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div ' +
        (false ? '' : 'style="display: none;"') +
        ' class="popup-footer">' +
        '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
        data.imei +
        '" id="custom-btn-1-' +
        data.imei +
        '" title="Ver historial del día">' +
        // '<i class="fas fa-history"></i>' +
        '<span>Recorrido hoy</span>' +
        '</button>' +
        '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
        data.imei +
        '" id="custom-btn-2-' +
        data.imei +
        '" title="Crear historial personalizado">' +
        // '<i class="fas fa-cog"></i>' +
        '<span>Elegir fecha</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<style>' +
        '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
        '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
        '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
        '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
        '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
        '.popup-body { padding: 8px 10px; background: white; }' +
        '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
        '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
        '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
        '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
        '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
        '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
        '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
        '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
        '.location-link:hover { text-decoration: underline; }' +
        '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
        '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
        '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
        '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
        '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
        '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
        '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
        '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
        '.btn-modern i { font-size: 10px; }' +
        '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
        '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
        '.copy-btn i { font-size: 10px; }' +
        '</style>';
    } else {
      newContent =
        '<div class="modern-popup-container">' +
        '<div class="popup-header">' +
        '<div class="vehicle-info">' +
        '<h6 class="vehicle-name" id="vehicle-name-' +
        data.imei +
        '" title="Copiar nombre del vehículo">' +
        data.name +
        '</h6>' +
        '<span class="speed-badge">' +
        data.speed +
        ' km/h</span>' +
        '</div>' +
        '</div>' +
        '<div class="popup-body">' +
        '<div class="info-grid">' +
        '<div class="info-item">' +
        '<i class="fas fa-user-circle" title="Conductor"></i>' +
        // '<span class="info-label">Conductor:</span>' +
        '<span class="info-value" id="driver-' +
        data.imei +
        '-content">' +
        data.namedriver +
        '</span>' +
        '<button class="copy-btn" id="driver-' +
        data.imei +
        '" title="Copiar conductor">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
        // '<span class="info-label">Ubicación:</span>' +
        '<a href="' +
        googleMapsLink +
        '" target="_blank" class="location-link" id="location-' +
        data.imei +
        '-content">' +
        data.latitud +
        ', ' +
        data.longitud +
        '</a>' +
        '<button class="copy-btn" id="location-' +
        data.imei +
        '" title="Copiar ubicación">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
        // '<span class="info-label">Referencia:</span>' +
        '<span class="info-value" id="reference-' +
        data.imei +
        '-content">' +
        data.ref +
        '</span>' +
        '<button class="copy-btn" id="reference-' +
        data.imei +
        '" title="Copiar referencia">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-clock" title="Transmisión"></i>' +
        // '<span class="info-label">Transmisión:</span>' +
        '<span class="info-value" id="transmission-' +
        data.imei +
        '-content">' +
        dt_tracker +
        '</span>' +
        '<button class="copy-btn" id="transmission-' +
        data.imei +
        '" title="Copiar transmisión">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
        // '<span class="info-label">T. Detenido:</span>' +
        '<span class="info-value" id="stoptime-' +
        data.imei +
        '-content">' +
        data.tiempoParada +
        '</span>' +
        '<button class="copy-btn" id="stoptime-' +
        data.imei +
        '" title="Copiar tiempo de parada">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div ' +
        (false ? '' : 'style="display: none;"') +
        ' class="popup-footer">' +
        '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
        data.imei +
        '" id="custom-btn-1-' +
        data.imei +
        '" title="Ver historial del día">' +
        // '<i class="fas fa-history"></i>' +
        '<span>Recorrido hoy</span>' +
        '</button>' +
        '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
        data.imei +
        '" id="custom-btn-2-' +
        data.imei +
        '" title="Crear historial personalizado">' +
        // '<i class="fas fa-cog"></i>' +
        '<span>Elegir fecha</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<style>' +
        // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
        // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
        // '.leaflet-popup-close-button { display: none !important; }' +
        '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
        '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
        '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
        '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
        '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
        '.popup-body { padding: 8px 10px; background: white; }' +
        '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
        '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
        '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
        '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
        '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
        '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
        '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
        '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
        '.location-link:hover { text-decoration: underline; }' +
        '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
        '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
        '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
        '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
        '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
        '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
        '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
        '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
        '.btn-modern i { font-size: 10px; }' +
        '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
        '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
        '.copy-btn i { font-size: 10px; }' +
        '</style>';
    }

    // const tempMarker = L.marker([data.latitud, data.longitud], {icon: iconMarker});//.addTo(map).bindPopup(popupText);
    const tempMarker = L.marker([data.latitud, data.longitud], {
      icon: iconMarker,
    })
      .setZIndexOffset(1)
      .bindPopup(newContent);

    tempMarker.bindTooltip(`<span>${data.name}</span>`, {
      permanent: true,
      offset: [0, 12],
      className: 'vehicle-tooltip',
    });
    let options = {
      imei: data.IMEI,
      name: data.name,
      nameconvoy: data.nameconvoy,
      namegrupo: data.namegrupo,
      nameoperation: data.nameoperation,
      namedriver: data.namedriver,
      longitud: data.longitud,
      latitud: data.latitud,
      speed: data.speed,
      dt_tracker: data.dt_tracker,
      paradaDesde: '',
      vehicleService: this.vehicleService,
    };
    // console.log('envia cero data',data.speed);
    // console.log('envia cero XD',options);

    // tempMarker.on('click', this.timeStop, options);
    tempMarker.on('click', () => this.timeStop(options));

    // tempMarker.on('click',this.timeStop,options);
    // // this
    this.marker[data.IMEI] = tempMarker;

    mapItem.markerClusterGroup.addLayer(tempMarker, { renderer: L.canvas() });
    mapItem.markerClusterGroup.addTo(mapItem.map, { renderer: L.canvas() });

    setTimeout(() => {
      // Configurar listeners para botones de copiar en la segunda sección
      this.setCopyListener(
        `driver-${data.imei}`,
        data.namedriver,
        `driver-${data.imei}-content`
      );
      this.setCopyListener(
        `location-${data.imei}`,
        `${data.latitud}, ${data.longitud}`,
        `location-${data.imei}-content`
      );
      this.setCopyListener(
        `reference-${data.imei}`,
        data.ref,
        `reference-${data.imei}-content`
      );
      this.setCopyListener(
        `transmission-${data.imei}`,
        dt_tracker,
        `transmission-${data.imei}-content`
      );
      this.setCopyListener(
        `stoptime-${data.imei}`,
        data.tiempoParada,
        `stoptime-${data.imei}-content`
      );
      this.setCopyListener(`vehicle-name-${data.imei}`, data.name);
    }, 100);
  }

  public timeStop(vhDataDefault: any): void {
    // consultar data actual
    // let vehicle = this.vehicleService.getVehicle(this.imei);
    let vehicle = this.vehicleService.getVehicle(vhDataDefault.imei);

    vhDataDefault.speed = vehicle.speed;
    vhDataDefault.dt_tracker = vehicle.dt_tracker;
    vhDataDefault.longitud = vehicle.longitud;
    vhDataDefault.latitud = vehicle.latitud;

    console.log('calculando time stop ...');

    let ar_vel = vhDataDefault.speed;
    if (vhDataDefault.speed > 3) {
      ar_vel = vhDataDefault.speed;
      vhDataDefault.paradaDesde = false;
    } else {
      if (vhDataDefault.paradaDesde == false) {
        ar_vel = vhDataDefault.speed;
      } else {
        ar_vel = -1; // velocidad mayor a 6 para que no traiga historial
      }
    }

    // let f_ini = moment(new Date())
    //   .add(-1, 'days')
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    // let f_fin = moment(new Date())
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');

    let f_ini = this.momentService.getDateUTCWithOptions(
      -1,
      'days',
      'YYYY-MM-DD HH:mm:ss'
    );
    let f_fin = this.momentService.getDateUTCWithOptions(
      undefined,
      undefined,
      'YYYY-MM-DD HH:mm:ss'
    );

    let params = {
      imei: vhDataDefault.imei,
      name: vehicle.name,
      nameconvoy: vehicle.nameconvoy,
      namegrupo: vehicle.namegrupo,
      nameoperation: vehicle.nameoperation,
      namedriver: vehicle.namedriver,
      longitud: vhDataDefault.longitud,
      latitud: vhDataDefault.latitud,
      speed: vhDataDefault.speed,
      dt_tracker: vhDataDefault.dt_tracker,
      paradaDesde: vhDataDefault.paradaDesde,
      fecha_i: f_ini,
      fecha_f: f_fin,
      vel: ar_vel,
    };

    this.vehicleService.postTimeStop(params);
  }

  // printPopup(data: any, mapItem: IMapMinimap): void {
  //   console.log('data final printpopup', data);
  //   let layers = mapItem.markerClusterGroup.getLayers();

  //   let key = Object.keys(layers).find(key => layers[key]._leaflet_id == this.marker[data.imei!]._leaflet_id)
  //   if(key != undefined && key){
  //     const nameGroup = this.setNameGroup(
  //       data.nameoperation,
  //       data.namegrupo,
  //       data.nameconvoy
  //     );
  //     const googleMapsLink = `https://www.google.com/maps?q=${data.latitud},${data.longitud}`;
  //     let newContent;
  //     if (nameGroup) {
  //       // mapItem.markerClusterGroup.getLayers()[key]['_popup'].setContent(
  //       newContent = '<div class="row"><div class="col-6" align="left"><strong>' +
  //           data.name +
  //           '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
  //           data.speed +
  //           ' km/h</strong></div></div>' +
  //           '<aside class="">' +
  //           '<small>' +
  //           nameGroup +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor"><i class="fas fa-user-circle"> Conductor: </i></span>' +
  //           data.namedriver +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Ubicacion"><i class="fas fa-crosshairs"> Ubicacion: </i></span><a href=" ' +
  //           googleMapsLink +
  //           '" target="_blank">' +
  //           data.latitud +
  //           ', ' +
  //           data.longitud +
  //           '</a></small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Referencia"><i class="fas fa-map-marked-alt"> Referencia: </i></span> ' +
  //           data.ref +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Fecha de Transmision"><i class="fas fa-calendar-alt"> Fehca de Transmision: </i></span> ' +
  //           data.dt_tracker +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tiempo de Parada"><i class="fas fa-hourglass-half"> Tiempo de Parada: </i></span>' +
  //           data.tiempoParada +
  //           '</small>' +
  //           '</aside>';
  //       // );
  //     } else {
  //       // mapItem.markerClusterGroup.getLayers()[key]['_popup'].setContent(
  //         newContent = '<div class="row"><div class="col-6" align="left"><strong>' +
  //           data.name +
  //           '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
  //           data.speed +
  //           ' km/h</strong></div></div>' +
  //           '<aside class="">' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor"><i class="fas fa-user-circle"> Conductor: </i></span>' +
  //           data.namedriver +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Ubicacion"><i class="fas fa-crosshairs"> Ubicacion: </i></span><a href=" ' +
  //           googleMapsLink +
  //           '" target="_blank">' +
  //           data.latitud +
  //           ', ' +
  //           data.longitud +
  //           '</a></small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Referencia"><i class="fas fa-map-marked-alt"> Referencia: </i></span> ' +
  //           data.ref +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Fecha de Transmision"><i class="fas fa-calendar-alt"> Fecha de Transmision: </i></span> ' +
  //           data.dt_tracker +
  //           '</small><br>' +
  //           '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tiempo de Parada"><i class="fas fa-hourglass-half"> Tiempo de Parada: </i></span>' +
  //           data.tiempoParada +
  //           '</small>' +
  //           '</aside>';
  //       // );
  //     }
  //     mapItem.markerClusterGroup.getLayers()[key]['_popup'].setContent(newContent)
  //   }

  //   for (const key in layers) {
  //     if (
  //       layers[key]['_tooltip']['_content'] ==
  //       this.marker[data.imei]._tooltip._content
  //     ) {
  //       // console.log("this.markerClusterGroup.getLayers()[key]",this.markerClusterGroup.getLayers()[key]);

  //       // Eliminar el tooltip activo
  //       /*  const activeTooltip = document.querySelector('.tooltip');
  //        if (activeTooltip) {
  //          activeTooltip.remove();
  //        } */

  //       }
  //   }
  // }

  printPopup(data: any, mapItem: IMapMinimap): void {
    let object = mapItem.markerClusterGroup.getLayers();
    // console.log('objetc ', this.marker[data.imei]);
    // console.log('data ', data);
    console.log('printpopup', data);

    if (data?.imei) {
      try {
        const vehicle = this.vehicleService.getVehicle(data.imei);
        if (
          vehicle?.name &&
          typeof vehicle.name === 'string' &&
          vehicle.name.trim()
        ) {
          data.name = vehicle.name;
        }
      } catch (error) {
        console.warn(
          'Error al asignar vehicle name para IMEI:',
          data.imei,
          error
        );
      }
    }

    let key = Object.keys(object).find(
      (key) => object[key]._leaflet_id == this.marker[data.imei!]._leaflet_id
    );
    if (key != undefined && key) {
      const nameGroup = this.setNameGroup(
        data.nameoperation,
        data.namegrupo,
        data.nameconvoy
      );
      const googleMapsLink = `https://www.google.com/maps?q=${data.latitud},${data.longitud}`;
      const dt_tracker = data.dt_tracker
        ? (() => {
            try {
              const dateStr = data.dt_tracker.toString().trim();

              // Normalizar AM/PM con espacios flexibles
              let normalizedDateStr = dateStr
                .replace(/p\.\s*m\./gi, 'PM')
                .replace(/a\.\s*m\./gi, 'AM')
                .replace(/\s+/g, ' '); // Normalizar espacios múltiples

              // Regex más flexible para diferentes formatos
              const dateTimeMatch = normalizedDateStr.match(
                /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}),?\s*(.+)/
              );

              if (dateTimeMatch) {
                const [, day, month, year, time] = dateTimeMatch;
                normalizedDateStr = `${month}/${day}/${year} ${time}`;
              }

              const parsedDate = new Date(normalizedDateStr);

              if (isNaN(parsedDate.getTime())) {
                console.error('(MAP) ERROR AL PARSEAR FECHA:', {
                  original: dateStr,
                  normalized: normalizedDateStr,
                  parsedDate: parsedDate,
                  getTime: parsedDate.getTime(),
                });
                return '00/00/0000 00:00:00';
              }

              return parsedDate
                .toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })
                .replace(',', '');
            } catch (error) {
              console.error(
                '❌ ERROR INESPERADO AL PARSEAR FECHA:',
                error,
                data.dt_tracker
              );
              return '00/00/0000 00:00:00';
            }
          })()
        : '00/00/0000 00:00:00';

      let hasPermission = false;
      const permissionList = localStorage.getItem('PermissionList');
      if (permissionList) {
        const content: string[] = JSON.parse(permissionList ?? '[]');
        hasPermission = content.some(
          (permission) => permission === 'vehicle_history'
        );
      }

      let newContent;
      if (nameGroup) {
        newContent =
          '<div class="modern-popup-container">' +
          '<div class="popup-header">' +
          '<div class="vehicle-info">' +
          '<h6 class="vehicle-name" id="vehicle-name-' +
          data.imei +
          '" title="Copiar nombre del vehículo">' +
          data.name +
          '</h6>' +
          '<span class="speed-badge">' +
          data.speed +
          ' km/h</span>' +
          '</div>' +
          '</div>' +
          '<div class="popup-body">' +
          '<div class="group-info">' +
          '<i class="fas fa-layer-group text-muted"></i>' +
          '<span class="group-name">' +
          nameGroup +
          '</span>' +
          '</div>' +
          '<div class="info-grid">' +
          '<div class="info-item">' +
          '<i class="fas fa-user-circle" title="Conductor"></i>' +
          //'<span class="info-label">Conductor:</span>' +
          '<span class="info-value" id="driver-' +
          data.imei +
          '-content">' +
          data.namedriver +
          '</span>' +
          '<button class="copy-btn" id="driver-' +
          data.imei +
          '" title="Copiar conductor">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
          // '<span class="info-label">Ubicación:</span>' +
          '<a href="' +
          googleMapsLink +
          '" target="_blank" class="location-link" id="location-' +
          data.imei +
          '-content">' +
          data.latitud +
          ', ' +
          data.longitud +
          '</a>' +
          '<button class="copy-btn" id="location-' +
          data.imei +
          '" title="Copiar ubicación">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
          // '<span class="info-label">Referencia:</span>' +
          '<span class="info-value" id="reference-' +
          data.imei +
          '-content">' +
          data.ref +
          '</span>' +
          '<button class="copy-btn" id="reference-' +
          data.imei +
          '" title="Copiar referencia">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-clock" title="Transmisión"></i>' +
          // '<span class="info-label">Transmisión:</span>' +
          '<span class="info-value" id="transmission-' +
          data.imei +
          '-content">' +
          dt_tracker +
          '</span>' +
          '<button class="copy-btn" id="transmission-' +
          data.imei +
          '" title="Copiar transmisión">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-pause-circle" title="Tiempo Detenedio"></i>' +
          // '<span class="info-label">T. Detenedio:</span>' +
          '<span class="info-value" id="stoptime-' +
          data.imei +
          '-content">' +
          data.tiempoParada +
          '</span>' +
          '<button class="copy-btn" id="stoptime-' +
          data.imei +
          '" title="Copiar tiempo de parada">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div ' +
          (false ? '' : 'style="display: none;"') +
          ' class="popup-footer">' +
          '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
          data.imei +
          '" id="custom-btn-1-' +
          data.imei +
          '" title="Ver historial del día">' +
          // '<i class="fas fa-history"></i>' +
          '<span>Recorrido hoy</span>' +
          '</button>' +
          '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
          data.imei +
          '" id="custom-btn-2-' +
          data.imei +
          '" title="Crear historial personalizado">' +
          // '<i class="fas fa-cog"></i>' +
          '<span>Elegir fecha</span>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '<style>' +
          '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
          '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
          '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
          '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
          '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
          '.popup-body { padding: 8px 10px; background: white; }' +
          '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
          '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
          '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
          '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
          '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
          '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
          '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
          '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
          '.location-link:hover { text-decoration: underline; }' +
          '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
          '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
          '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
          '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
          '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
          '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
          '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
          '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
          '.btn-modern i { font-size: 10px; }' +
          '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
          '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
          '.copy-btn i { font-size: 10px; }' +
          '</style>';
      } else {
        newContent =
          '<div class="modern-popup-container">' +
          '<div class="popup-header">' +
          '<div class="vehicle-info">' +
          '<h6 class="vehicle-name" id="vehicle-name-' +
          data.imei +
          '" title="Copiar nombre del vehículo">' +
          data.name +
          '</h6>' +
          '<span class="speed-badge">' +
          data.speed +
          ' km/h</span>' +
          '</div>' +
          '</div>' +
          '<div class="popup-body">' +
          '<div class="info-grid">' +
          '<div class="info-item">' +
          '<i class="fas fa-user-circle" title="Conductor"></i>' +
          // '<span class="info-label">Conductor:</span>' +
          '<span class="info-value" id="driver-' +
          data.imei +
          '-content">' +
          data.namedriver +
          '</span>' +
          '<button class="copy-btn" id="driver-' +
          data.imei +
          '" title="Copiar conductor">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
          // '<span class="info-label">Ubicación:</span>' +
          '<a href="' +
          googleMapsLink +
          '" target="_blank" class="location-link" id="location-' +
          data.imei +
          '-content">' +
          data.latitud +
          ', ' +
          data.longitud +
          '</a>' +
          '<button class="copy-btn" id="location-' +
          data.imei +
          '" title="Copiar ubicación">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
          // '<span class="info-label">Referencia:</span>' +
          '<span class="info-value" id="reference-' +
          data.imei +
          '-content">' +
          data.ref +
          '</span>' +
          '<button class="copy-btn" id="reference-' +
          data.imei +
          '" title="Copiar referencia">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-clock" title="Transmisión"></i>' +
          // '<span class="info-label">Transmisión:</span>' +
          '<span class="info-value" id="transmission-' +
          data.imei +
          '-content">' +
          dt_tracker +
          '</span>' +
          '<button class="copy-btn" id="transmission-' +
          data.imei +
          '" title="Copiar transmisión">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
          // '<span class="info-label">T. Detenido:</span>' +
          '<span class="info-value" id="stoptime-' +
          data.imei +
          '-content">' +
          data.tiempoParada +
          '</span>' +
          '<button class="copy-btn" id="stoptime-' +
          data.imei +
          '" title="Copiar tiempo de parada">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div ' +
          (false ? '' : 'style="display: none;"') +
          ' class="popup-footer">' +
          '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
          data.imei +
          '" id="custom-btn-1-' +
          data.imei +
          '" title="Ver historial del día">' +
          // '<i class="fas fa-history"></i>' +
          '<span>Recorrido hoy</span>' +
          '</button>' +
          '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
          data.imei +
          '" id="custom-btn-2-' +
          data.imei +
          '" title="Crear historial personalizado">' +
          // '<i class="fas fa-cog"></i>' +
          '<span>Elegir fecha</span>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '<style>' +
          // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
          // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
          // '.leaflet-popup-close-button { display: none !important; }' +
          '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
          '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
          '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
          '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
          '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
          '.popup-body { padding: 8px 10px; background: white; }' +
          '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
          '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
          '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
          '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
          '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
          '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
          '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
          '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
          '.location-link:hover { text-decoration: underline; }' +
          '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
          '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
          '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
          '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
          '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
          '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
          '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
          '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
          '.btn-modern i { font-size: 10px; }' +
          '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
          '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
          '.copy-btn i { font-size: 10px; }' +
          '</style>';
      }
      mapItem.markerClusterGroup
        .getLayers()
        [key]['_popup'].setContent(newContent);

      setTimeout(() => {
        // Configurar listeners para botones de copiar en la segunda sección
        this.setCopyListener(
          `driver-${data.imei}`,
          data.namedriver,
          `driver-${data.imei}-content`
        );
        this.setCopyListener(
          `location-${data.imei}`,
          `${data.latitud}, ${data.longitud}`,
          `location-${data.imei}-content`
        );
        this.setCopyListener(
          `reference-${data.imei}`,
          data.ref,
          `reference-${data.imei}-content`
        );
        this.setCopyListener(
          `transmission-${data.imei}`,
          dt_tracker,
          `transmission-${data.imei}-content`
        );
        this.setCopyListener(
          `stoptime-${data.imei}`,
          data.tiempoParada,
          `stoptime-${data.imei}-content`
        );
        this.setCopyListener(`vehicle-name-${data.imei}`, data.name);
      }, 100);
    }
  }

  string_diffechas(a: any, b: any): any {
    let c = Math.floor((b - a) / 1000) % 60;
    let d = Math.floor((b - a) / 60000) % 60;
    let e = Math.floor((b - a) / 3600000) % 24;
    let f = Math.floor((b - a) / 86400000);
    let g = '';
    if (f > 0) {
      g = '' + f + ' d ' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (e > 0) {
      g = '' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (d > 0) {
      g = '' + d + ' min ' + c + ' s';
    } else if (c >= 0) {
      g = '' + c + ' s';
    }
    return g;
  }

  diffSecondsNow(fecha: string): boolean {
    // Obtener la fecha y hora actual
    const fechaActual = moment();
    // Parsear la fecha proporcionada
    const fechaComparar = moment(fecha);
    // Calcular la diferencia en segundos
    const diferenciaEnSegundos = fechaActual.diff(fechaComparar, 'seconds');
    // Comprobar si la diferencia es mayor a 15 segundos
    // console.log('Diff ',diferenciaEnSegundos);
    // console.log('Resulta ',diferenciaEnSegundos>15);
    return diferenciaEnSegundos > 15;
  }

  public async calculateDirection(coord1: any, coord2: any): Promise<string> {
    const angle =
      Math.atan2(coord1.lat - coord2.lat, coord1.lng - coord2.lng) *
      (180 / Math.PI);

    if (angle > -22.5 && angle <= 22.5) return 'right';
    if (angle > 22.5 && angle <= 67.5) return 'upright';
    if (angle > 67.5 && angle <= 112.5) return 'up';
    if (angle > 112.5 && angle <= 157.5) return 'upleft';
    if (angle > 157.5 || angle <= -157.5) return 'left';
    if (angle > -157.5 && angle <= -112.5) return 'downleft';
    if (angle > -112.5 && angle <= -67.5) return 'down';
    if (angle > -67.5 && angle <= -22.5) return 'downright';

    return '';
  }

  public getStateVehicle(vehicle: UserTracker): string {
    //console.log("vehicle",vehicle)
    if (vehicle.speed != 0 && vehicle.speed! < vehicle.limit_speed!) {
      return 'movement';
    } else if (vehicle.speed == 0) {
      return 'relenti';
    } else if (vehicle.speed != 0 && vehicle.speed! > vehicle.limit_speed!) {
      return 'excess';
    }
    return 'default';
  }

  public async renderVehiclesTransmission(map: IMapMinimap) {
    const vehicles = map.minimapConf.vehicles || [];

    for (const vehicle of vehicles) {
      if (!vehicle.IMEI) continue;

      const imei = vehicle.IMEI;
      const direction = vehicle.direction;
      const unit = this.getUnitTransmissionByIMEI(imei);
      vehicle.unit = unit || undefined;
      let iconUrl = '';

      if (unit) {
        const unitTransmissionId = unit.transmissionStatusId.toString();

        if (unitTransmissionId === vehicle.unitTransmission) {
          continue;
        }

        iconUrl = direction
          ? this.userIconsService.getTransmissionIconDirectionUnsafe(
              unit.unitTypeId,
              unitTransmissionId,
              direction
            )
          : this.userIconsService.getTransmissionIconUnsafe(
              unit.unitTypeId,
              unitTransmissionId
            );

        vehicle.unitTransmission = unitTransmissionId;
      }

      if (!iconUrl) {
        iconUrl = this.userIconsService.getDirectionSvg(
          vehicle.tipo!,
          'default',
          direction
        );
        vehicle.direction = direction;
      }

      const layers = await map.markerClusterGroup.getLayers();
      const marker = this.marker[imei];
      const key = Object.keys(layers).find(
        (k) => layers[k]._leaflet_id === marker['_leaflet_id']
      );

      if (key) {
        const coord = {
          lat: vehicle.latitud,
          lng: vehicle.longitud,
        };
        const currentMarker = layers[key];
        currentMarker.options.icon.options.iconUrl = iconUrl;
        currentMarker.options.icon.options.shadowSize = [30, 30];
        currentMarker.setLatLng(coord);
      }
    }
  }

  private async monitor(data: any): Promise<void> {
    const maps = this.currentMaps;

    maps.forEach(async (item) => {
      const resultado = item.minimapConf?.vehicles!.find(
        (vehi) => vehi.IMEI?.toString() == data.IMEI.toString()
      );

      if (resultado) {
        const index = item.minimapConf!.vehicles!.indexOf(resultado);
        // data.fecha_tracker = moment(data.fecha_tracker).subtract(5, 'hours').format('YYYY-MM-DD HH:mm:ss');
        data.fecha_tracker = this.momentService.toLocal(
          data.fecha_tracker,
          true
        ) as string;

        // TRAMAS EXCLUIDAS POR VOLCADO
        if (
          item.minimapConf!.vehicles![index].dt_tracker! > data.fecha_tracker
        ) {
          // console.log('TRAMA **************************',data.IMEI);
          // console.log('TRAMA dt vehicle:',vehicles[index].dt_tracker);
          // console.log('TRAMA dt (VOLCADO):',fecha_tracker);
          return;
        }

        if (
          item.minimapConf!.vehicles![index].dt_tracker != data.fecha_tracker &&
          item.minimapConf!.vehicles![index].driver_id != data.driver_id &&
          !this.diffSecondsNow(data.fecha_tracker)
        ) {
          // OBTENER EL NOMBRE EN BASE AL ID DRIVER
          item.minimapConf!.vehicles![index].namedriver =
            this.driversService.getDriverById(data.driver_id);
          item.minimapConf!.vehicles![index].id_conductor = data.driver_id;
          // console.log(
          //   'DRIVER MINIMAP->',
          //   data.IMEI,
          //   ' - ',
          //   data.driver_id,
          //   ':',
          //   item.minimapConf!.vehicles![index].namedriver
          // );
        }
        item.minimapConf!.vehicles![index].latitud = data.Latitud.toString();
        item.minimapConf!.vehicles![index].longitud = data.Longitud.toString();
        item.minimapConf!.vehicles![index].speed = data.Velocidad;
        item.minimapConf!.vehicles![index].dt_server = data.fecha_server;
        // item.minimapConf!.vehicles![index].dt_tracker = moment(data.fecha_tracker).subtract(5, 'hours').format('YYYY-MM-DD HH:mm:ss');
        item.minimapConf!.vehicles![index].dt_tracker = data.fecha_tracker;
        item.minimapConf!.vehicles![index].altitud = data.Altitud;
        item.minimapConf!.vehicles![index].señal_gps = data.señal_gps;
        item.minimapConf!.vehicles![index].señal_gsm = data.señal_gsm;
        item.minimapConf!.vehicles![index].parametros = data.Parametros;
        item.minimapConf!.vehicles![index] = this.vehicleService.formatVehicle(
          item.minimapConf!.vehicles![index]
        );

        if (item.imeiPopup == data.IMEI.toString()) {
          let options = {
            imei: data.IMEI,
            name: item.minimapConf!.vehicles![index].name,
            nameconvoy: item.minimapConf!.vehicles![index].nameconvoy,
            namegrupo: item.minimapConf!.vehicles![index].namegrupo,
            nameoperation: item.minimapConf!.vehicles![index].nameoperation,
            namedriver: item.minimapConf!.vehicles![index].namedriver,
            longitud: data.Longitud,
            latitud: data.Latitud,
            speed: data.Velocidad,
            dt_tracker: item.minimapConf!.vehicles![index].dt_tracker, //luego de pasar por filtro
            paradaDesde: '',
            // vehicleService: this.vehicleService,
          };
          this.timeStopAux(options);
        }

        if (item.minimapConf!.vehicles![index].eye) {
          let cont = 0;
          let object = item.markerClusterGroup.getLayers();

          let key = Object.keys(object).find(
            (key) =>
              object[key]._leaflet_id ==
              this.marker[item.minimapConf!.vehicles![index].IMEI!][
                '_leaflet_id'
              ]
          );
          if (key != undefined && key) {
            // }
            // console.log(item.minimapConf!.vehicles![index]);
            let oldCoords = item.markerClusterGroup
              .getLayers()
              [key].getLatLng();

            let coord = {
              lat: parseFloat(item.minimapConf!.vehicles![index].latitud!),
              lng: parseFloat(item.minimapConf!.vehicles![index].longitud!),
            };
            // for (const key in object) {
            // if (
            //   object[key]['_tooltip']['_content'] ==
            //   '<span>' + item.minimapConf!.vehicles![index].name + '</span>'
            // ) {

            if (
              item.minimapConf!.vehicles![index].parametros!.includes('di4=') ||
              item.minimapConf!.vehicles![index].parametros!.includes(
                'Custom_ign='
              )
            ) {
              // let iconUrl = await MinimapService.loadAndConvertSVGToPNG(
              //   await this.userIconsService.getDirectionSvg(item.minimapConf!.vehicles![index].tipo!,'default')
              // );
              let iconUrl = this.getIconUrlTransmission(
                item.minimapConf!.vehicles![index]
              );

              if (
                item.minimapConf!.vehicles![index].parametros!.includes(
                  'di4=1'
                ) ||
                item.minimapConf!.vehicles![index].parametros!.includes(
                  'Custom_ign=1'
                )
              ) {
                if (
                  this.userIconsService.changeRotateIcon == true &&
                  this.userIconsService.stateCustomDirectionSvg == true
                ) {
                  this.dif_mayor = 0.0;
                  this.dif_divide = 0.0;
                  this.dif_X = 0.0;
                  this.dif_Y = 0.0;
                  this.direction = '';
                  this.final_direction = '';
                  this.direction_X = '';
                  this.direction_Y = '';

                  if (
                    coord.lat != oldCoords.lat &&
                    coord.lng != oldCoords.lng
                  ) {
                    this.direction = await this.calculateDirection(
                      coord,
                      oldCoords
                    );
                    iconUrl = this.getIconUrlTransmissionDirection(
                      item.minimapConf!.vehicles![index],
                      this.direction
                    );
                    //iconUrl = await this.userIconsService.getDirectionSvg(item.minimapConf!.vehicles![index].tipo!,'default',this.direction);
                  }
                }

                if (this.userIconsService.changeItemIcon == 'vehicles') {
                  if (
                    this.userIconsService.changeRotateIcon == true &&
                    this.userIconsService.stateVehiclesDirectionSvg == true
                  ) {
                    this.dif_mayor = 0.0;
                    this.dif_divide = 0.0;
                    this.dif_X = 0.0;
                    this.dif_Y = 0.0;
                    this.direction = '';
                    this.final_direction = '';
                    this.direction_X = '';
                    this.direction_Y = '';

                    if (
                      coord.lat != oldCoords.lat &&
                      coord.lng != oldCoords.lng
                    ) {
                      this.direction = await this.calculateDirection(
                        coord,
                        oldCoords
                      );
                      let state = this.getStateVehicle(
                        item.minimapConf!.vehicles![index]
                      );
                      iconUrl = this.getIconUrlTransmissionDirection(
                        item.minimapConf!.vehicles![index],
                        this.direction
                      );
                      //iconUrl = await this.userIconsService.getDirectionSvg(item.minimapConf!.vehicles![index].tipo!,state,this.direction);
                    }
                  } else {
                    let state = this.getStateVehicle(
                      item.minimapConf!.vehicles![index]
                    );
                    iconUrl = this.getIconUrlTransmission(
                      item.minimapConf!.vehicles![index]
                    );

                    //iconUrl = await this.userIconsService.getDirectionSvg(item.minimapConf!.vehicles![index].tipo!,state);
                  }
                } else if (this.userIconsService.changeItemIcon == 'ondas') {
                  let iconUrl2 = await this.getUrlByStateOndas(
                    item.minimapConf!.vehicles![index]
                  );
                  item.markerClusterGroupOnda.getLayers()[key]['options'][
                    'icon'
                  ]['options']['iconUrl'] = iconUrl2;
                  item.markerClusterGroupOnda.getLayers()[key].setLatLng(coord);
                }

                if (item.minimapConf!.vehicles![index].speed != 0) {
                  this.dif_mayor = 0.0;
                  this.dif_divide = 0.0;
                  this.dif_X = 0.0;
                  this.dif_Y = 0.0;
                  this.direction = '';
                  this.final_direction = '';
                  this.direction_X = '';
                  this.direction_Y = '';

                  if (
                    coord.lat != oldCoords.lat &&
                    coord.lng != oldCoords.lng
                  ) {
                    if (coord.lat > oldCoords.lat) {
                      //arriba
                      this.direction_Y = 'up';
                      this.dif_Y = coord.lat - oldCoords.lat;
                      if (this.dif_Y >= this.dif_mayor) {
                        this.dif_mayor = this.dif_Y;
                        this.direction = 'up';
                        this.dif_divide = this.dif_Y / 2;
                      }
                    } else {
                      //abajo
                      this.direction_Y = 'down';
                      this.dif_Y = oldCoords.lat - coord.lat;
                      if (this.dif_Y >= this.dif_mayor) {
                        this.dif_mayor = this.dif_Y;
                        this.direction = 'down';
                        this.dif_divide = this.dif_Y / 2;
                      }
                    }

                    if (coord.lng > oldCoords.lng) {
                      //derecha
                      this.direction_X = 'right';
                      this.dif_X = coord.lng - oldCoords.lng;
                      if (this.dif_X >= this.dif_mayor) {
                        this.dif_mayor = this.dif_X;
                        this.direction = 'right';
                        this.dif_divide = this.dif_X / 2;
                      }
                    } else {
                      //izquierda
                      this.direction_X = 'left';
                      this.dif_X = oldCoords.lng - coord.lng;
                      if (this.dif_X >= this.dif_mayor) {
                        this.dif_mayor = this.dif_X;
                        this.direction = 'left';
                        this.dif_divide = this.dif_X / 2;
                      }
                    }

                    if (this.direction == 'up' || this.direction == 'down') {
                      if (this.dif_X >= this.dif_divide) {
                        this.final_direction = `${this.direction}-${this.direction_X}`;
                      } else {
                        this.final_direction = `${this.direction}`;
                      }
                    } else {
                      if (this.dif_Y >= this.dif_divide) {
                        this.final_direction = `${this.direction_Y}-${this.direction}`;
                      } else {
                        this.final_direction = `${this.direction}`;
                      }
                    }

                    if (
                      this.userIconsService.changeItemIcon == 'cursor' &&
                      item.minimapConf!.vehicles![index].speed! >
                        item.minimapConf!.vehicles![index].limit_speed!
                    ) {
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options'][
                        'shadowUrl'
                      ] = `./assets/images/excessCursor/arrow_${this.final_direction}.webp`;
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowAnchor'] = [14, 60];
                    } else {
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options'][
                        'shadowUrl'
                      ] = `./assets/images/arrow_${this.final_direction}.webp`;
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowAnchor'] = [14, 60];
                    }
                  } else {
                    if (
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowUrl']
                    ) {
                      let old_direction = item.markerClusterGroup
                        .getLayers()
                        [key]['options']['icon']['options']['shadowUrl'].split(
                          '_'
                        );
                      if (
                        this.userIconsService.changeItemIcon == 'cursor' &&
                        item.minimapConf!.vehicles![index].speed! >
                          item.minimapConf!.vehicles![index].limit_speed!
                      ) {
                        item.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options'][
                          'shadowUrl'
                        ] = `./assets/images/excessCursor/arrow_${old_direction[1]}`;
                        item.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options']['shadowAnchor'] = [14, 60];
                      } else {
                        item.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options'][
                          'shadowUrl'
                        ] = `./assets/images/arrow_${old_direction[1]}`;
                        item.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options']['shadowAnchor'] = [14, 60];
                      }
                    } else {
                      item.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowUrl'] = '';
                    }
                  }
                } else if (
                  this.userIconsService.changeItemIcon == 'cursor' &&
                  item.minimapConf!.vehicles![index].speed == 0
                ) {
                  if (
                    item.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowUrl']
                  ) {
                    let old_direction = item.markerClusterGroup
                      .getLayers()
                      [key]['options']['icon']['options']['shadowUrl'].split(
                        '_'
                      );
                    item.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ][
                      'shadowUrl'
                    ] = `./assets/images/relentiCursor/arrow_${old_direction[1]}`;
                    item.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowAnchor'] = [14, 60];
                  } else {
                    item.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ][
                      'shadowUrl'
                    ] = `./assets/images/relentiCursor/arrow_down-left.webp`;
                    item.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowAnchor'] = [14, 60];
                  }
                } else {
                  item.markerClusterGroup.getLayers()[key]['options']['icon'][
                    'options'
                  ]['shadowUrl'] = '';
                }

                item.markerClusterGroup.getLayers()[key]['options']['icon'][
                  'options'
                ]['iconUrl'] = iconUrl;
                item.markerClusterGroup.getLayers()[key]['options']['icon'][
                  'options'
                ]['shadowSize'] = [30, 30];
              } else {
                // if(item.markerClusterGroup.getLayers()[key]['options']['icon']['options']['shadowUrl']){
                //   console.log('Remover Cursor',item.minimapConf!.vehicles![index].IMEI);
                //   item.markerClusterGroup.getLayers()[key]['options']['icon']['options']['shadowUrl'] = '';
                // }
              }

              // REVISAR FUNCION ES NECESARIO?
              // this.timeChangeIconUrl(item.minimapConf!.vehicles![index].IMEI!,item.minimapConf!.vehicles![index].tipo!,item,key);

              const googleMapsLink = `https://www.google.com/maps?q=${
                item.minimapConf!.vehicles![index].latitud
              },${item.minimapConf!.vehicles![index].longitud}`;
              const nameGroup = this.setNameGroup(
                item.minimapConf!.vehicles![index].nameoperation!,
                item.minimapConf!.vehicles![index].namegrupo!,
                item.minimapConf!.vehicles![index].nameconvoy!
              );

              const data =
                item.minimapConf!.vehicles![index].dt_tracker || undefined;

              const dt_tracker = data
                ? (() => {
                    try {
                      const dateStr = data.toString().trim();

                      // Normalizar AM/PM con espacios flexibles
                      let normalizedDateStr = dateStr
                        .replace(/p\.\s*m\./gi, 'PM')
                        .replace(/a\.\s*m\./gi, 'AM')
                        .replace(/\s+/g, ' '); // Normalizar espacios múltiples

                      // Regex más flexible para diferentes formatos
                      const dateTimeMatch = normalizedDateStr.match(
                        /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}),?\s*(.+)/
                      );

                      if (dateTimeMatch) {
                        const [, day, month, year, time] = dateTimeMatch;
                        normalizedDateStr = `${month}/${day}/${year} ${time}`;
                      }

                      const parsedDate = new Date(normalizedDateStr);

                      if (isNaN(parsedDate.getTime())) {
                        console.error('(MAP) ERROR AL PARSEAR FECHA:', {
                          original: dateStr,
                          normalized: normalizedDateStr,
                          parsedDate: parsedDate,
                          getTime: parsedDate.getTime(),
                        });
                        return '00/00/0000 00:00:00';
                      }

                      return parsedDate
                        .toLocaleString('es-ES', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false,
                        })
                        .replace(',', '');
                    } catch (error) {
                      console.error(
                        '❌ ERROR INESPERADO AL PARSEAR FECHA:',
                        error,
                        data
                      );
                      return '00/00/0000 00:00:00';
                    }
                  })()
                : '00/00/0000 00:00:00';
              let hasPermission = false;
              const permissionList = localStorage.getItem('PermissionList');
              if (permissionList) {
                const content: string[] = JSON.parse(permissionList ?? '[]');
                hasPermission = content.some(
                  (permission) => permission === 'vehicle_history'
                );
              }

              if (nameGroup) {
                item.markerClusterGroup.getLayers()[key]['_popup']['_content'] =
                  // '<div class="row"><div class="col-6" align="left"><strong>' +
                  // item.minimapConf!.vehicles![index].name +
                  // '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
                  // item.minimapConf!.vehicles![index].speed +
                  // ' km/h</strong></div></div>' +
                  // '<aside class="">' +
                  // // '<small>CONVOY: '+item.minimapConf!.vehicles![index].nameconvoy+'</small><br>'+
                  // '<small>' +
                  // nameGroup +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor"><i class="fas fa-user-circle"> Conductor: </i></span>' +
                  // item.minimapConf!.vehicles![index].namedriver +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Ubicacion"><i class="fas fa-crosshairs"> Ubicacion: </i></span><a href=" ' +
                  // googleMapsLink +
                  // '" target="_blank">' +
                  // item.minimapConf!.vehicles![index].latitud +
                  // ', ' +
                  // item.minimapConf!.vehicles![index].longitud +
                  // '</a></small><br>' +
                  // // '<small>UBICACION: '+item.minimapConf!.vehicles![index].latitud+', '+item.minimapConf!.vehicles![index].longitud+'</small><br>'+
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Referencia"><i class="fas fa-map-marked-alt"> Referencia: </i></span> ' +
                  // 'Calculando ...' +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Fecha de Transmision"><i class="fas fa-calendar-alt"> Fehca de Transmision: </i></span> ' +
                  // item.minimapConf!.vehicles![index].dt_tracker +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tiempo de Parada"><i class="fas fa-hourglass-half"> Tiempo de Parada: </i></span> Calculando ...</small>' +
                  // '</aside>';
                  '<div class="modern-popup-container">' +
                  '<div class="popup-header">' +
                  '<div class="vehicle-info">' +
                  '<h6 class="vehicle-name" id="vehicle-name-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar nombre del vehículo">' +
                  item.minimapConf!.vehicles![index].name +
                  '</h6>' +
                  '<span class="speed-badge">' +
                  item.minimapConf!.vehicles![index].speed +
                  ' km/h</span>' +
                  '</div>' +
                  '</div>' +
                  '<div class="popup-body">' +
                  '<div class="group-info">' +
                  '<i class="fas fa-layer-group text-muted"></i>' +
                  '<span class="group-name">' +
                  nameGroup +
                  '</span>' +
                  '</div>' +
                  '<div class="info-grid">' +
                  '<div class="info-item">' +
                  '<i class="fas fa-user-circle" title="Conductor"></i>' +
                  //'<span class="info-label">Conductor:</span>' +
                  '<span class="info-value" id="driver-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  item.minimapConf!.vehicles![index].namedriver +
                  '</span>' +
                  '<button class="copy-btn" id="driver-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar conductor">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
                  // '<span class="info-label">Ubicación:</span>' +
                  '<a href="' +
                  googleMapsLink +
                  '" target="_blank" class="location-link" id="location-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  item.minimapConf!.vehicles![index].latitud +
                  ', ' +
                  item.minimapConf!.vehicles![index].longitud +
                  '</a>' +
                  '<button class="copy-btn" id="location-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar ubicación">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-clock" title="Transmisión"></i>' +
                  // '<span class="info-label">Transmisión:</span>' +
                  '<span class="info-value" id="transmission-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  dt_tracker +
                  '</span>' +
                  '<button class="copy-btn" id="transmission-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar transmisión">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '<div ' +
                  (false ? '' : 'style="display: none;"') +
                  ' class="popup-footer">' +
                  '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" id="custom-btn-1-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Ver historial del día">' +
                  // '<i class="fas fa-history"></i>' +
                  '<span>Recorrido hoy</span>' +
                  '</button>' +
                  '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" id="custom-btn-2-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Crear historial personalizado">' +
                  // '<i class="fas fa-cog"></i>' +
                  '<span>Elegir fecha</span>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '<style>' +
                  '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
                  '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
                  '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
                  '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
                  '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
                  '.popup-body { padding: 8px 10px; background: white; }' +
                  '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
                  '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
                  '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
                  '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
                  '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
                  '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
                  '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
                  '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
                  '.location-link:hover { text-decoration: underline; }' +
                  '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
                  '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
                  '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
                  '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
                  '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
                  '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
                  '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
                  '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
                  '.btn-modern i { font-size: 10px; }' +
                  '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
                  '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
                  '.copy-btn i { font-size: 10px; }' +
                  '</style>';
              } else {
                item.markerClusterGroup.getLayers()[key]['_popup']['_content'] =
                  // '<div class="row"><div class="col-6" align="left"><strong>' +
                  // item.minimapConf!.vehicles![index].name +
                  // '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
                  // item.minimapConf!.vehicles![index].speed +
                  // ' km/h</strong></div></div>' +
                  // '<aside class="">' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor"><i class="fas fa-user-circle"> Conductor: </i></span> ' +
                  // item.minimapConf!.vehicles![index].namedriver +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Ubicacion"><i class="fas fa-crosshairs"> Ubicacion: </i></span><a href=" ' +
                  // googleMapsLink +
                  // '" target="_blank">' +
                  // item.minimapConf!.vehicles![index].latitud +
                  // ', ' +
                  // item.minimapConf!.vehicles![index].longitud +
                  // '</a></small><br>' +
                  // // '<small>UBICACION: '+item.minimapConf!.vehicles![index].latitud+', '+item.minimapConf!.vehicles![index].longitud+'</small><br>'+
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Referencia"><i class="fas fa-map-marked-alt"> Referencia: </i></span> ' +
                  // 'Calculando ...' +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Fecha de Transmision"><i class="fas fa-calendar-alt"> Fehca de Transmision: </i></span> ' +
                  // item.minimapConf!.vehicles![index].dt_tracker +
                  // '</small><br>' +
                  // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tiempo de Parada"><i class="fas fa-hourglass-half"> Tiempo de Parada: </i></span> Calculando ...</small>' +
                  // '</aside>';

                  '<div class="modern-popup-container">' +
                  '<div class="popup-header">' +
                  '<div class="vehicle-info">' +
                  '<h6 class="vehicle-name" id="vehicle-name-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar nombre del vehículo">' +
                  item.minimapConf!.vehicles![index].name +
                  '</h6>' +
                  '<span class="speed-badge">' +
                  item.minimapConf!.vehicles![index].speed +
                  ' km/h</span>' +
                  '</div>' +
                  '</div>' +
                  '<div class="popup-body">' +
                  '<div class="info-grid">' +
                  '<div class="info-item">' +
                  '<i class="fas fa-user-circle" title="Conductor"></i>' +
                  // '<span class="info-label">Conductor:</span>' +
                  '<span class="info-value" id="driver-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  item.minimapConf!.vehicles![index].namedriver +
                  '</span>' +
                  '<button class="copy-btn" id="driver-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar conductor">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
                  // '<span class="info-label">Ubicación:</span>' +
                  '<a href="' +
                  googleMapsLink +
                  '" target="_blank" class="location-link" id="location-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  item.minimapConf!.vehicles![index].latitud +
                  ', ' +
                  item.minimapConf!.vehicles![index].longitud +
                  '</a>' +
                  '<button class="copy-btn" id="location-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar ubicación">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-clock" title="Transmisión"></i>' +
                  // '<span class="info-label">Transmisión:</span>' +
                  '<span class="info-value" id="transmission-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '-content">' +
                  dt_tracker +
                  '</span>' +
                  '<button class="copy-btn" id="transmission-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Copiar transmisión">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '<div ' +
                  (false ? '' : 'style="display: none;"') +
                  ' class="popup-footer">' +
                  '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" id="custom-btn-1-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Ver historial del día">' +
                  // '<i class="fas fa-history"></i>' +
                  '<span>Recorrido hoy</span>' +
                  '</button>' +
                  '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" id="custom-btn-2-' +
                  item.minimapConf!.vehicles![index].IMEI +
                  '" title="Crear historial personalizado">' +
                  // '<i class="fas fa-cog"></i>' +
                  '<span>Elegir fecha</span>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '<style>' +
                  // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
                  // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
                  // '.leaflet-popup-close-button { display: none !important; }' +
                  '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
                  '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
                  '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
                  '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
                  '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
                  '.popup-body { padding: 8px 10px; background: white; }' +
                  '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
                  '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
                  '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
                  '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
                  '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
                  '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
                  '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
                  '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
                  '.location-link:hover { text-decoration: underline; }' +
                  '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
                  '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
                  '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
                  '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
                  '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
                  '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
                  '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
                  '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
                  '.btn-modern i { font-size: 10px; }' +
                  '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
                  '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
                  '.copy-btn i { font-size: 10px; }' +
                  '</style>';
              }
            } else {
              // console.log('TRAMA IGNORADA NO CAMBIA ESTADO VEHICULO ----->',vehicles[index].IMEI);
            }
            item.markerClusterGroup.getLayers()[key].setLatLng(coord);
            // let aux = item.markerClusterGroup.getLayers()[key];
            const auxdataFitBounds = item.getDataFitBounds(
              item.minimapConf.vehicles!
            );
            if (item.minimapConf.followUnits) {
              item.setViewMap(auxdataFitBounds);
              if (auxdataFitBounds.length > 0) {
                item.setFitBounds(auxdataFitBounds);
              }
            }
            // }
          }
        }
        this.mapsSubject.next([...maps]);
      }
    });
  }


  public focusMap(containerId : string, vehicles : UserTracker[] = []){
    const maps = this.currentMaps;
    const map = maps.find((map) => map.minimapConf.mapConf?.containerId == containerId )
    if(!map) return;

    this.focusMapSubject.next(containerId)

    let auxdataFitBounds: [number, number][];
    if (vehicles.length > 0) {
      const vehicle = vehicles[0];
      auxdataFitBounds = [[parseFloat(vehicle.latitud!), parseFloat(vehicle.longitud!)]];
    } else {
      auxdataFitBounds = map.getDataFitBounds(map.minimapConf.vehicles!);
    }
    map.setViewMap(auxdataFitBounds);
    if (auxdataFitBounds.length > 0) {
      map.setFitBounds(auxdataFitBounds);
      // map.map?.invalidateSize(); // Forzar re-renderizado
    }
    // 🔄 Si ya había un temporizador, lo cancelamos
    this.focusTimer?.unsubscribe();

    // 🕓 Después de 3 segundos, limpiar el focus
    this.focusTimer = timer(3000).subscribe(() => {
      this.focusMapSubject.next(null);
    });
  }

  public addMap(mapItem: IMapMinimap): void {
    this.maps.push(mapItem);
    this.onDrawIcon(mapItem);
  }

  public timeStopAux(data: any): void {
    // console.log("calculando time stop aux ...");

    let ar_vel = data.speed;
    if (data.speed > 3) {
      ar_vel = data.speed;
      data.paradaDesde = false;
    } else {
      if (data.paradaDesde == false) {
        ar_vel = data.speed;
      } else {
        ar_vel = -1; // velocidad mayor a 6 para que no traiga historial
      }
    }

    // let f_ini = moment(new Date())
    //   .add(-1, 'days')
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    // let f_fin = moment(new Date())
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    let f_ini = this.momentService.getDateUTCWithOptions(
      -1,
      'days',
      'YYYY-MM-DD HH:mm:ss'
    );
    let f_fin = this.momentService.getDateUTCWithOptions(
      undefined,
      undefined,
      'YYYY-MM-DD HH:mm:ss'
    );

    let params = {
      imei: data.imei,
      name: data.name,
      nameconvoy: data.nameconvoy,
      namegrupo: data.namegrupo,
      nameoperation: data.nameoperation,
      namedriver: data.namedriver,
      longitud: data.longitud,
      latitud: data.latitud,
      speed: data.speed,
      dt_tracker: data.dt_tracker,
      paradaDesde: data.paradaDesde,
      fecha_i: f_ini,
      fecha_f: f_fin,
      vel: ar_vel,
    };

    this.vehicleService.postTimeStop(params);
  }

  public changeClusteringVisibility(visibility: boolean) {
    this.clustering = visibility;
  }

  public get getClustering(): boolean {
    return this.clustering;
  }
  static async loadAndConvertSVGToPNG(svgURL: string): Promise<string> {
    // Crear un elemento de imagen
    const img = new Image();

    // Cargar el SVG desde la URL
    return new Promise<string>((resolve, reject) => {
      img.onload = async () => {
        // Crear un elemento de lienzo para convertir la imagen
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');

        if (ctx) {
          // Dibujar la imagen en el lienzo
          ctx.drawImage(img, 0, 0, img.width, img.height);

          // Convertir el lienzo a un formato PNG
          const dataURL = canvas.toDataURL('image/png');
          canvas.remove();
          resolve(dataURL);
        } else {
          reject('Failed to get 2D context for canvas');
        }
      };

      img.onerror = () => {
        reject('Failed to load SVG image');
      };

      img.src = svgURL;
    });
  }
  public timeChangeIconUrl(imei: string, type: string, itemMap: any, key: any) {
    // this.timeWait = 5000; // 150 segundos en milisegundos

    if (this.timeNow[imei]) {
      clearTimeout(this.timeNow[imei]); // Limpia el temporizador existente si hay uno para este índice
      // console.log('SE LIMPIO EL TEMPORIZADOR del -->',imei);
    }
    const tiempoUltimaActualizacion = Date.now(); // Actualiza el tiempo de la última actualización para este índice
    // console.log('CREANDO TEMPORIZADOR NUEVO -->',imei);
    this.timeNow[imei] = setTimeout(async () => {
      // Verifica si ha pasado el tiempo especificado desde la última actualización
      const tiempoActual = Date.now();
      const tiempoTranscurrido = tiempoActual - tiempoUltimaActualizacion;
      if (tiempoTranscurrido >= this.timeWait) {
        // Realiza la acción si ha pasado el tiempo especificado sin actualización
        const iconUrl = await MinimapService.loadAndConvertSVGToPNG(
          await this.userIconsService.getDirectionSvg(type, 'default')
        );
        console.log(
          '*************** PASO 2 Horas Cambiando color a default ---->',
          imei
        );

        // item.markerClusterGroup.getLayers()[key]['options']['icon']['options']['iconUrl']=iconUrl;
        itemMap.markerClusterGroup.getLayers()[key]['options']['icon'][
          'options'
        ]['iconUrl'] = iconUrl;
        itemMap.markerClusterGroup.getLayers()[key]['options']['icon'][
          'options'
        ]['shadowUrl'] = '';
        if (this.userIconsService.changeItemIcon == 'ondas') {
          itemMap.markerClusterGroupOnda.getLayers()[key]['options']['icon'][
            'options'
          ]['iconUrl'] = './assets/images/objects/nuevo/gif/blanco.png';
        }
      }
    }, this.timeWait);
  }

  private async hasParamIgnition(vehicle: UserTracker): Promise<boolean> {
    return (
      vehicle.parametros!.includes('di4=') ||
      vehicle.parametros!.includes('Custom_ign=')
    );
  }
  private async checkParamIgnition(vehicle: UserTracker): Promise<boolean> {
    // return (vehicle.parametros!.includes('di4=1') || vehicle.parametros!.includes('Custom_ign=1') ||  vehicle.v_on == 1);
    return vehicle.v_on == 1;
  }
  private async setIconUrlByState(vehicle: UserTracker) {
    let state: string = 'default';
    let iconUrl: any;
    if (
      this.userIconsService.changeItemIcon == 'vehicles' &&
      this.userIconsService.stateVehiclesDirectionSvg == true
    ) {
      state = this.getStateVehicle(vehicle);
      iconUrl = await MinimapService.loadAndConvertSVGToPNG(
        await this.userIconsService.getDirectionSvg(vehicle.tipo!, state)
      );
    } else {
      iconUrl = await this.userIconsService.getDirectionSvg(
        vehicle.tipo!,
        state
      );
    }
    // console.log(vehicle.IMEI,vehicle.tipo,state);
    return iconUrl;
  }
  private async setIconUrlOndaByState(vehicle: UserTracker) {
    const iconOndaUrl = await this.getUrlByStateOndas(vehicle);
    return iconOndaUrl;
  }

  private getUnitTransmissionByIMEI(
    imei: string
  ): UnitWithTransmissionStatus | null {
    const unit = this.units.find((unit) => unit.device.IMEI === imei);
    if (
      !unit ||
      unit.transmissionStatusId === undefined ||
      unit.transmissionStatusId === null
    ) {
      return null;
    }
    return unit;
  }

  private getIconUrlTransmission(vehicle: UserTracker): string {
    let iconUrl = '';
    if (vehicle.IMEI) {
      const imei = vehicle.IMEI;

      if (imei) {
        let unit = this.getUnitTransmissionByIMEI(imei);
        vehicle.unit = unit || undefined;
        if (unit) {
          (iconUrl = this.userIconsService.getTransmissionIconUnsafe(
            unit.unitTypeId,
            unit.transmissionStatusId.toString()
          )),
            (vehicle.unitTransmission = unit.transmissionStatusId.toString());
        }
      }
    }
    if (!iconUrl) {
      iconUrl = this.userIconsService.getDirectionSvg(vehicle.tipo!, 'default');
    }

    return iconUrl;
  }
  private getIconUrlTransmissionDirection(
    vehicle: UserTracker,
    direction: string
  ): string {
    let iconUrl = '';
    if (vehicle.IMEI) {
      const imei = vehicle.IMEI;

      if (imei) {
        let unit = this.getUnitTransmissionByIMEI(imei);
        vehicle.unit = unit || undefined;
        if (unit) {
          iconUrl = this.userIconsService.getTransmissionIconDirectionUnsafe(
            unit.unitTypeId,
            unit.transmissionStatusId.toString(),
            direction
          );
          vehicle.unitTransmission = unit.transmissionStatusId.toString();
        }
      }
    }
    if (!iconUrl) {
      iconUrl = this.userIconsService.getDirectionSvg(
        vehicle.tipo!,
        'default',
        direction
      );
      vehicle.direction = direction;
    }

    return iconUrl;
  }

  private setCopyListener(id: string, value: string, contentId?: string) {
    const elButton = document.getElementById(id);
    const elContent = contentId
      ? document.getElementById(contentId)
      : document.getElementById(id);
    if (elButton) {
      elButton.onclick = () => {
        navigator.clipboard.writeText(value);
        if (elContent) {
          const original = elContent.innerHTML;
          if (original === '¡Copiado!') return;
          elContent.innerHTML = '¡Copiado!';
          setTimeout(() => {
            elContent.innerHTML = original;
          }, 1500);
        }
      };
    }
  }
}
